/* Generated by scripts/generate-dcs-tools.ts
 * *DO NOT EDIT MANUALLY*
 */

import type { ResultError } from '@core/util/result';
import { err, ok, type Result } from 'neverthrow';
import { bookingLinkHistory } from '../../booking-link-history';
import * as schemas from './schemas';
import type * as types from './types';

type ToolParserMap = {
  BashCodeExecution: {
    call: types.BashCodeExecution;
    response: types.BashCodeExecutionResponse;
  };
  BulkSetEntityPropertyOptions: {
    call: types.BulkSetEntityPropertyOptions;
    response: types.BulkSetEntityPropertyOptionsResponse;
  };
  CalculateSpreadsheet: {
    call: types.CalculateSpreadsheet;
    response: types.SpreadsheetResponse;
  };
  CommentOnDocument: {
    call: types.CommentOnDocument;
    response: types.CommentOnDocumentResponse;
  };
  ConfigureAgent: {
    call: types.ConfigureAgent;
    response: types.ConfigureAgentResponse;
  };
  ConfigureBot: {
    call: types.ConfigureBot;
    response: types.ConfigureBotResponse;
  };
  ContentSearch: {
    call: types.ContentSearch;
    response: types.SearchToolResponse;
  };
  CreateBookingLink: {
    call: types.CreateBookingLink;
    response: types.BookingLinkResult;
  };
  CreateBot: { call: types.CreateBot; response: types.CreateBotResponse };
  CreateCalendarEvent: {
    call: types.CreateCalendarEvent;
    response: types.UserToolResponseForToolCalendarEvent;
  };
  CreateChannel: {
    call: types.CreateChannel;
    response: types.CreateChannelResponse;
  };
  CreateConfirmedCalendarEvent: {
    call: types.CreateConfirmedCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  CreateDocument: {
    call: types.CreateDocument;
    response: types.CreateDocumentResponse;
  };
  CreateForm: { call: types.CreateForm; response: types.MutationResult };
  CreateImportEntity: {
    call: types.CreateImportEntity;
    response: types.CreateImportEntityResponse;
  };
  CreateInitiative: {
    call: types.CreateInitiative;
    response: types.ProjectDetails;
  };
  CreateProject: {
    call: types.CreateProject;
    response: types.CreateProjectResponse;
  };
  CreateRoutine: { call: types.CreateRoutine; response: types.RoutineInfo };
  CreateTag: { call: types.CreateTag; response: types.CreateTagResponse };
  DeleteBot: { call: types.DeleteBot; response: types.DeleteBotResponse };
  DeleteCalendarEvent: {
    call: types.DeleteCalendarEvent;
    response: types.DeleteCalendarEventResponse;
  };
  DeleteDatabaseView: {
    call: types.DeleteDatabaseView;
    response: types.DeletedDatabaseView;
  };
  DeleteImportEntity: {
    call: types.DeleteImportEntity;
    response: types.DeleteImportEntityResponse;
  };
  DeleteInitiative: {
    call: types.DeleteInitiative;
    response: types.ProjectOperationComplete;
  };
  DeleteTag: { call: types.DeleteTag; response: types.DeleteTagResponse };
  DescribeDatabase: {
    call: types.DescribeDatabase;
    response: types.ToolDatabaseSchema;
  };
  DiscoverConnectors: {
    call: types.DiscoverConnectors;
    response: types.DiscoverConnectorsResponse;
  };
  DispatchCodingAgent: {
    call: types.DispatchCodingAgent;
    response: types.DispatchedCodingAgent;
  };
  DisplayResults: {
    call: types.DisplayResults;
    response: types.DisplayResultsResponse;
  };
  EditBookingLink: {
    call: types.EditBookingLink;
    response: types.BookingLinkResult;
  };
  EditDocument: {
    call: types.EditDocument;
    response: types.EditDocumentResponse;
  };
  EditForm: { call: types.EditForm; response: types.MutationResult };
  EditPresentation: {
    call: types.EditPresentation;
    response: types.PresentationEditOutcome;
  };
  EditSpreadsheet: {
    call: types.EditSpreadsheet;
    response: types.SpreadsheetResponse;
  };
  EditTag: { call: types.EditTag; response: types.EditTagResponse };
  EditWordDocument: {
    call: types.EditWordDocument;
    response: types.WordDocumentResponse;
  };
  GenerateImage: {
    call: types.GenerateImage;
    response: types.GenerateImageResponse;
  };
  GetBotWebhooks: {
    call: types.GetBotWebhooks;
    response: types.GetBotWebhooksResponse;
  };
  GetCompany: { call: types.GetCompany; response: types.GetCompanyResponse };
  GetEntityProperties: {
    call: types.GetEntityProperties;
    response: types.GetEntityPropertiesResponse;
  };
  GetTeamAvailability: {
    call: types.GetTeamAvailability;
    response: types.TeamAvailability;
  };
  GetThread: { call: types.GetThread; response: types.GetThreadResponse };
  ImportNotionPage: {
    call: types.ImportNotionPage;
    response: types.ImportNotionPageResponse;
  };
  IssueBotCredential: {
    call: types.IssueBotCredential;
    response: types.IssueBotCredentialResponse;
  };
  ListAgents: { call: types.ListAgents; response: types.ListAgentsResponse };
  ListBookingLinks: {
    call: types.ListBookingLinks;
    response: types.ListBookingLinksResult;
  };
  ListBots: { call: types.ListBots; response: types.ListBotsResponse };
  ListCalendarEvents: {
    call: types.ListCalendarEvents;
    response: types.ListCalendarEventsResponse;
  };
  ListCalendars: {
    call: types.ListCalendars;
    response: types.ListCalendarsToolResponse;
  };
  ListCodingAgents: {
    call: types.ListCodingAgents;
    response: types.ListCodingAgentsResponse;
  };
  ListCompanies: {
    call: types.ListCompanies;
    response: types.ListCompaniesResponse;
  };
  ListDatabases: {
    call: types.ListDatabases;
    response: types.ListDatabasesResponse;
  };
  ListEntities: {
    call: types.ListEntities;
    response: types.ListEntitiesResponse;
  };
  ListForms: { call: types.ListForms; response: types.ListResult };
  ListImportEntities: {
    call: types.ListImportEntities;
    response: types.ListImportEntitiesResponse;
  };
  ListInboxes: { call: types.ListInboxes; response: types.ListInboxesResponse };
  ListInitiatives: {
    call: types.ListInitiatives;
    response: types.ProjectListResult;
  };
  ListLabels: { call: types.ListLabels; response: types.ListLabelsResponse };
  ListNotifications: {
    call: types.ListNotifications;
    response: types.ListNotificationsResponse;
  };
  ListRoutines: { call: types.ListRoutines; response: types.RoutineList };
  ListSkills: { call: types.ListSkills; response: types.ListSkillsResponse };
  ListTags: { call: types.ListTags; response: types.ListTagsResponse };
  ListTeamMembers: {
    call: types.ListTeamMembers;
    response: types.ListTeamMembersResponse;
  };
  LoadTools: { call: types.LoadTools; response: types.LoadToolsResponse };
  ManageBotChannelAccess: {
    call: types.ManageBotChannelAccess;
    response: types.ManageBotChannelAccessResponse;
  };
  ManageChannelParticipants: {
    call: types.ManageChannelParticipants;
    response: types.ManageChannelParticipantsResponse;
  };
  MarkNotificationsDone: {
    call: types.MarkNotificationsDone;
    response: types.MarkNotificationsResponse;
  };
  MarkNotificationsSeen: {
    call: types.MarkNotificationsSeen;
    response: types.MarkNotificationsResponse;
  };
  MoveToProject: {
    call: types.MoveToProject;
    response: types.MoveToProjectResponse;
  };
  NameSearch: { call: types.NameSearch; response: types.SearchToolResponse };
  QueryDatabase: {
    call: types.QueryDatabase;
    response: types.QueryDatabaseResponse;
  };
  ReadActivity: {
    call: types.ReadActivity;
    response: types.ReadActivityResponse;
  };
  ReadCallRecord: {
    call: types.ReadCallRecord;
    response: types.ReadCallRecordResponse;
  };
  ReadChannelMessageContext: {
    call: types.ReadChannelMessageContext;
    response: types.ReadChannelMessageContextResponse;
  };
  ReadChannelMessages: {
    call: types.ReadChannelMessages;
    response: types.ReadChannelMessagesResponse;
  };
  ReadChannelThread: {
    call: types.ReadChannelThread;
    response: types.ReadChannelThreadResponse;
  };
  ReadChat: { call: types.ReadChat; response: types.ReadChatResponse };
  ReadContent: { call: types.ReadContent; response: types.ReadContentResponse };
  ReadDesign: { call: types.ReadDesign; response: types.ReadDesignResponse };
  ReadForm: { call: types.ReadForm; response: types.ReadResult };
  ReadIllustratorDocument: {
    call: types.ReadIllustratorDocument;
    response: types.ReadIllustratorDocumentResponse;
  };
  ReadInitiative: {
    call: types.ReadInitiative;
    response: types.ProjectReadResult;
  };
  ReadInitiativeActivity: {
    call: types.ReadInitiativeActivity;
    response: types.ProjectActivityResult;
  };
  ReadMetadata: {
    call: types.ReadMetadata;
    response: types.ReadMetadataResponse;
  };
  ReadPhotoshopDocument: {
    call: types.ReadPhotoshopDocument;
    response: types.ReadPhotoshopDocumentResponse;
  };
  ReadPresentation: {
    call: types.ReadPresentation;
    response: types.ReadPresentationResponse;
  };
  ReadProject: { call: types.ReadProject; response: types.ReadProjectResponse };
  ReadRoutine: { call: types.ReadRoutine; response: types.RoutineDetails };
  ReadSkill: { call: types.ReadSkill; response: types.ReadSkillResponse };
  ReadSpreadsheet: {
    call: types.ReadSpreadsheet;
    response: types.SpreadsheetResponse;
  };
  ReadThread: { call: types.ReadThread; response: types.ReadResponse };
  ReadWordDocument: {
    call: types.ReadWordDocument;
    response: types.WordDocumentResponse;
  };
  RenameChannel: {
    call: types.RenameChannel;
    response: types.RenameChannelResponse;
  };
  RenameDocument: {
    call: types.RenameDocument;
    response: types.RenameDocumentResponse;
  };
  ResolveDocumentComment: {
    call: types.ResolveDocumentComment;
    response: types.ResolveDocumentCommentResponse;
  };
  SaveDatabaseQuery: {
    call: types.SaveDatabaseQuery;
    response: types.SaveDatabaseQueryResponse;
  };
  SaveDatabaseView: {
    call: types.SaveDatabaseView;
    response: types.SavedDatabaseView;
  };
  SearchSkills: {
    call: types.SearchSkills;
    response: types.SearchSkillsResponse;
  };
  SearchTools: { call: types.SearchTools; response: types.SearchToolsResponse };
  SelfKnowledge: {
    call: types.SelfKnowledge;
    response: types.SelfKnowledgeResponse;
  };
  SendChannelMessage: {
    call: types.SendChannelMessage;
    response: types.SendChannelMessageResponse;
  };
  SendConfirmedEmail: {
    call: types.SendConfirmedEmail;
    response: types.SendEmailResponse;
  };
  SendEmail: {
    call: types.SendEmail;
    response: types.UserToolResponseForSendEmailResponse;
  };
  SetEntityProperty: {
    call: types.SetEntityProperty;
    response: types.SetEntityPropertyResponse;
  };
  SetFormAccess: { call: types.SetFormAccess; response: types.MutationResult };
  SetSenderPolicy: {
    call: types.SetSenderPolicy;
    response: types.SetSenderPolicyResponse;
  };
  ShareWithChannel: {
    call: types.ShareWithChannel;
    response: types.ShareWithChannelResponse;
  };
  Subagent: { call: types.Subagent; response: types.SubagentResponse };
  TextEditorCodeExecution: {
    call: types.TextEditorCodeExecution;
    response: types.TextEditorCodeExecutionResponse;
  };
  UpdateCalendarEvent: {
    call: types.UpdateCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  UpdateInitiative: {
    call: types.UpdateInitiative;
    response: types.ProjectDetails;
  };
  UpdateInitiativeSharing: {
    call: types.UpdateInitiativeSharing;
    response: types.ProjectDetails;
  };
  UpdateRoutine: { call: types.UpdateRoutine; response: types.RoutineInfo };
  UpdateThreadLabels: {
    call: types.UpdateThreadLabels;
    response: types.UpdateThreadLabelsResponse;
  };
  UploadFile: { call: types.UploadFile; response: types.UploadFileResponse };
  WebFetch: { call: types.WebFetch; response: types.WebFetchResponse };
  WebSearch: { call: types.WebSearch; response: types.WebSearchResponse };
};

const toolParserMap = {
  BashCodeExecution: {
    call: schemas.BashCodeExecution,
    response: schemas.BashCodeExecutionResponse,
  },
  BulkSetEntityPropertyOptions: {
    call: schemas.BulkSetEntityPropertyOptions,
    response: schemas.BulkSetEntityPropertyOptionsResponse,
  },
  CalculateSpreadsheet: {
    call: schemas.CalculateSpreadsheet,
    response: schemas.SpreadsheetResponse,
  },
  CommentOnDocument: {
    call: schemas.CommentOnDocument,
    response: schemas.CommentOnDocumentResponse,
  },
  ConfigureAgent: {
    call: schemas.ConfigureAgent,
    response: schemas.ConfigureAgentResponse,
  },
  ConfigureBot: {
    call: schemas.ConfigureBot,
    response: schemas.ConfigureBotResponse,
  },
  ContentSearch: {
    call: schemas.ContentSearch,
    response: schemas.SearchToolResponse,
  },
  CreateBookingLink: {
    call: schemas.CreateBookingLink,
    response: schemas.BookingLinkResult,
  },
  CreateBot: { call: schemas.CreateBot, response: schemas.CreateBotResponse },
  CreateCalendarEvent: {
    call: schemas.CreateCalendarEvent,
    response: schemas.UserToolResponseForToolCalendarEvent,
  },
  CreateChannel: {
    call: schemas.CreateChannel,
    response: schemas.CreateChannelResponse,
  },
  CreateConfirmedCalendarEvent: {
    call: schemas.CreateConfirmedCalendarEvent,
    response: schemas.ToolCalendarEvent,
  },
  CreateDocument: {
    call: schemas.CreateDocument,
    response: schemas.CreateDocumentResponse,
  },
  CreateForm: { call: schemas.CreateForm, response: schemas.MutationResult },
  CreateImportEntity: {
    call: schemas.CreateImportEntity,
    response: schemas.CreateImportEntityResponse,
  },
  CreateInitiative: {
    call: schemas.CreateInitiative,
    response: schemas.ProjectDetails,
  },
  CreateProject: {
    call: schemas.CreateProject,
    response: schemas.CreateProjectResponse,
  },
  CreateRoutine: { call: schemas.CreateRoutine, response: schemas.RoutineInfo },
  CreateTag: { call: schemas.CreateTag, response: schemas.CreateTagResponse },
  DeleteBot: { call: schemas.DeleteBot, response: schemas.DeleteBotResponse },
  DeleteCalendarEvent: {
    call: schemas.DeleteCalendarEvent,
    response: schemas.DeleteCalendarEventResponse,
  },
  DeleteDatabaseView: {
    call: schemas.DeleteDatabaseView,
    response: schemas.DeletedDatabaseView,
  },
  DeleteImportEntity: {
    call: schemas.DeleteImportEntity,
    response: schemas.DeleteImportEntityResponse,
  },
  DeleteInitiative: {
    call: schemas.DeleteInitiative,
    response: schemas.ProjectOperationComplete,
  },
  DeleteTag: { call: schemas.DeleteTag, response: schemas.DeleteTagResponse },
  DescribeDatabase: {
    call: schemas.DescribeDatabase,
    response: schemas.ToolDatabaseSchema,
  },
  DiscoverConnectors: {
    call: schemas.DiscoverConnectors,
    response: schemas.DiscoverConnectorsResponse,
  },
  DispatchCodingAgent: {
    call: schemas.DispatchCodingAgent,
    response: schemas.DispatchedCodingAgent,
  },
  DisplayResults: {
    call: schemas.DisplayResults,
    response: schemas.DisplayResultsResponse,
  },
  EditBookingLink: {
    call: schemas.EditBookingLink,
    response: schemas.BookingLinkResult,
  },
  EditDocument: {
    call: schemas.EditDocument,
    response: schemas.EditDocumentResponse,
  },
  EditForm: { call: schemas.EditForm, response: schemas.MutationResult },
  EditPresentation: {
    call: schemas.EditPresentation,
    response: schemas.PresentationEditOutcome,
  },
  EditSpreadsheet: {
    call: schemas.EditSpreadsheet,
    response: schemas.SpreadsheetResponse,
  },
  EditTag: { call: schemas.EditTag, response: schemas.EditTagResponse },
  EditWordDocument: {
    call: schemas.EditWordDocument,
    response: schemas.WordDocumentResponse,
  },
  GenerateImage: {
    call: schemas.GenerateImage,
    response: schemas.GenerateImageResponse,
  },
  GetBotWebhooks: {
    call: schemas.GetBotWebhooks,
    response: schemas.GetBotWebhooksResponse,
  },
  GetCompany: {
    call: schemas.GetCompany,
    response: schemas.GetCompanyResponse,
  },
  GetEntityProperties: {
    call: schemas.GetEntityProperties,
    response: schemas.GetEntityPropertiesResponse,
  },
  GetTeamAvailability: {
    call: schemas.GetTeamAvailability,
    response: schemas.TeamAvailability,
  },
  GetThread: { call: schemas.GetThread, response: schemas.GetThreadResponse },
  ImportNotionPage: {
    call: schemas.ImportNotionPage,
    response: schemas.ImportNotionPageResponse,
  },
  IssueBotCredential: {
    call: schemas.IssueBotCredential,
    response: schemas.IssueBotCredentialResponse,
  },
  ListAgents: {
    call: schemas.ListAgents,
    response: schemas.ListAgentsResponse,
  },
  ListBookingLinks: {
    call: schemas.ListBookingLinks,
    response: schemas.ListBookingLinksResult,
  },
  ListBots: { call: schemas.ListBots, response: schemas.ListBotsResponse },
  ListCalendarEvents: {
    call: schemas.ListCalendarEvents,
    response: schemas.ListCalendarEventsResponse,
  },
  ListCalendars: {
    call: schemas.ListCalendars,
    response: schemas.ListCalendarsToolResponse,
  },
  ListCodingAgents: {
    call: schemas.ListCodingAgents,
    response: schemas.ListCodingAgentsResponse,
  },
  ListCompanies: {
    call: schemas.ListCompanies,
    response: schemas.ListCompaniesResponse,
  },
  ListDatabases: {
    call: schemas.ListDatabases,
    response: schemas.ListDatabasesResponse,
  },
  ListEntities: {
    call: schemas.ListEntities,
    response: schemas.ListEntitiesResponse,
  },
  ListForms: { call: schemas.ListForms, response: schemas.ListResult },
  ListImportEntities: {
    call: schemas.ListImportEntities,
    response: schemas.ListImportEntitiesResponse,
  },
  ListInboxes: {
    call: schemas.ListInboxes,
    response: schemas.ListInboxesResponse,
  },
  ListInitiatives: {
    call: schemas.ListInitiatives,
    response: schemas.ProjectListResult,
  },
  ListLabels: {
    call: schemas.ListLabels,
    response: schemas.ListLabelsResponse,
  },
  ListNotifications: {
    call: schemas.ListNotifications,
    response: schemas.ListNotificationsResponse,
  },
  ListRoutines: { call: schemas.ListRoutines, response: schemas.RoutineList },
  ListSkills: {
    call: schemas.ListSkills,
    response: schemas.ListSkillsResponse,
  },
  ListTags: { call: schemas.ListTags, response: schemas.ListTagsResponse },
  ListTeamMembers: {
    call: schemas.ListTeamMembers,
    response: schemas.ListTeamMembersResponse,
  },
  LoadTools: { call: schemas.LoadTools, response: schemas.LoadToolsResponse },
  ManageBotChannelAccess: {
    call: schemas.ManageBotChannelAccess,
    response: schemas.ManageBotChannelAccessResponse,
  },
  ManageChannelParticipants: {
    call: schemas.ManageChannelParticipants,
    response: schemas.ManageChannelParticipantsResponse,
  },
  MarkNotificationsDone: {
    call: schemas.MarkNotificationsDone,
    response: schemas.MarkNotificationsResponse,
  },
  MarkNotificationsSeen: {
    call: schemas.MarkNotificationsSeen,
    response: schemas.MarkNotificationsResponse,
  },
  MoveToProject: {
    call: schemas.MoveToProject,
    response: schemas.MoveToProjectResponse,
  },
  NameSearch: {
    call: schemas.NameSearch,
    response: schemas.SearchToolResponse,
  },
  QueryDatabase: {
    call: schemas.QueryDatabase,
    response: schemas.QueryDatabaseResponse,
  },
  ReadActivity: {
    call: schemas.ReadActivity,
    response: schemas.ReadActivityResponse,
  },
  ReadCallRecord: {
    call: schemas.ReadCallRecord,
    response: schemas.ReadCallRecordResponse,
  },
  ReadChannelMessageContext: {
    call: schemas.ReadChannelMessageContext,
    response: schemas.ReadChannelMessageContextResponse,
  },
  ReadChannelMessages: {
    call: schemas.ReadChannelMessages,
    response: schemas.ReadChannelMessagesResponse,
  },
  ReadChannelThread: {
    call: schemas.ReadChannelThread,
    response: schemas.ReadChannelThreadResponse,
  },
  ReadChat: { call: schemas.ReadChat, response: schemas.ReadChatResponse },
  ReadContent: {
    call: schemas.ReadContent,
    response: schemas.ReadContentResponse,
  },
  ReadDesign: {
    call: schemas.ReadDesign,
    response: schemas.ReadDesignResponse,
  },
  ReadForm: { call: schemas.ReadForm, response: schemas.ReadResult },
  ReadIllustratorDocument: {
    call: schemas.ReadIllustratorDocument,
    response: schemas.ReadIllustratorDocumentResponse,
  },
  ReadInitiative: {
    call: schemas.ReadInitiative,
    response: schemas.ProjectReadResult,
  },
  ReadInitiativeActivity: {
    call: schemas.ReadInitiativeActivity,
    response: schemas.ProjectActivityResult,
  },
  ReadMetadata: {
    call: schemas.ReadMetadata,
    response: schemas.ReadMetadataResponse,
  },
  ReadPhotoshopDocument: {
    call: schemas.ReadPhotoshopDocument,
    response: schemas.ReadPhotoshopDocumentResponse,
  },
  ReadPresentation: {
    call: schemas.ReadPresentation,
    response: schemas.ReadPresentationResponse,
  },
  ReadProject: {
    call: schemas.ReadProject,
    response: schemas.ReadProjectResponse,
  },
  ReadRoutine: { call: schemas.ReadRoutine, response: schemas.RoutineDetails },
  ReadSkill: { call: schemas.ReadSkill, response: schemas.ReadSkillResponse },
  ReadSpreadsheet: {
    call: schemas.ReadSpreadsheet,
    response: schemas.SpreadsheetResponse,
  },
  ReadThread: { call: schemas.ReadThread, response: schemas.ReadResponse },
  ReadWordDocument: {
    call: schemas.ReadWordDocument,
    response: schemas.WordDocumentResponse,
  },
  RenameChannel: {
    call: schemas.RenameChannel,
    response: schemas.RenameChannelResponse,
  },
  RenameDocument: {
    call: schemas.RenameDocument,
    response: schemas.RenameDocumentResponse,
  },
  ResolveDocumentComment: {
    call: schemas.ResolveDocumentComment,
    response: schemas.ResolveDocumentCommentResponse,
  },
  SaveDatabaseQuery: {
    call: schemas.SaveDatabaseQuery,
    response: schemas.SaveDatabaseQueryResponse,
  },
  SaveDatabaseView: {
    call: schemas.SaveDatabaseView,
    response: schemas.SavedDatabaseView,
  },
  SearchSkills: {
    call: schemas.SearchSkills,
    response: schemas.SearchSkillsResponse,
  },
  SearchTools: {
    call: schemas.SearchTools,
    response: schemas.SearchToolsResponse,
  },
  SelfKnowledge: {
    call: schemas.SelfKnowledge,
    response: schemas.SelfKnowledgeResponse,
  },
  SendChannelMessage: {
    call: schemas.SendChannelMessage,
    response: schemas.SendChannelMessageResponse,
  },
  SendConfirmedEmail: {
    call: schemas.SendConfirmedEmail,
    response: schemas.SendEmailResponse,
  },
  SendEmail: {
    call: schemas.SendEmail,
    response: schemas.UserToolResponseForSendEmailResponse,
  },
  SetEntityProperty: {
    call: schemas.SetEntityProperty,
    response: schemas.SetEntityPropertyResponse,
  },
  SetFormAccess: {
    call: schemas.SetFormAccess,
    response: schemas.MutationResult,
  },
  SetSenderPolicy: {
    call: schemas.SetSenderPolicy,
    response: schemas.SetSenderPolicyResponse,
  },
  ShareWithChannel: {
    call: schemas.ShareWithChannel,
    response: schemas.ShareWithChannelResponse,
  },
  Subagent: { call: schemas.Subagent, response: schemas.SubagentResponse },
  TextEditorCodeExecution: {
    call: schemas.TextEditorCodeExecution,
    response: schemas.TextEditorCodeExecutionResponse,
  },
  UpdateCalendarEvent: {
    call: schemas.UpdateCalendarEvent,
    response: schemas.ToolCalendarEvent,
  },
  UpdateInitiative: {
    call: schemas.UpdateInitiative,
    response: schemas.ProjectDetails,
  },
  UpdateInitiativeSharing: {
    call: schemas.UpdateInitiativeSharing,
    response: schemas.ProjectDetails,
  },
  UpdateRoutine: { call: schemas.UpdateRoutine, response: schemas.RoutineInfo },
  UpdateThreadLabels: {
    call: schemas.UpdateThreadLabels,
    response: schemas.UpdateThreadLabelsResponse,
  },
  UploadFile: {
    call: schemas.UploadFile,
    response: schemas.UploadFileResponse,
  },
  WebFetch: { call: schemas.WebFetch, response: schemas.WebFetchResponse },
  WebSearch: { call: schemas.WebSearch, response: schemas.WebSearchResponse },
};

export type ToolName = keyof ToolParserMap;

type NamedRawTool = {
  id: string;
  name: string;
  json: unknown;
};

type ToolDataMap = {
  BashCodeExecution: {
    call: types.BashCodeExecution;
    response: types.BashCodeExecutionResponse;
  };
  BulkSetEntityPropertyOptions: {
    call: types.BulkSetEntityPropertyOptions;
    response: types.BulkSetEntityPropertyOptionsResponse;
  };
  CalculateSpreadsheet: {
    call: types.CalculateSpreadsheet;
    response: types.SpreadsheetResponse;
  };
  CommentOnDocument: {
    call: types.CommentOnDocument;
    response: types.CommentOnDocumentResponse;
  };
  ConfigureAgent: {
    call: types.ConfigureAgent;
    response: types.ConfigureAgentResponse;
  };
  ConfigureBot: {
    call: types.ConfigureBot;
    response: types.ConfigureBotResponse;
  };
  ContentSearch: {
    call: types.ContentSearch;
    response: types.SearchToolResponse;
  };
  CreateBookingLink: {
    call: types.CreateBookingLink;
    response: types.BookingLinkResult;
  };
  CreateBot: { call: types.CreateBot; response: types.CreateBotResponse };
  CreateCalendarEvent: {
    call: types.CreateCalendarEvent;
    response: types.UserToolResponseForToolCalendarEvent;
  };
  CreateChannel: {
    call: types.CreateChannel;
    response: types.CreateChannelResponse;
  };
  CreateConfirmedCalendarEvent: {
    call: types.CreateConfirmedCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  CreateDocument: {
    call: types.CreateDocument;
    response: types.CreateDocumentResponse;
  };
  CreateForm: { call: types.CreateForm; response: types.MutationResult };
  CreateImportEntity: {
    call: types.CreateImportEntity;
    response: types.CreateImportEntityResponse;
  };
  CreateInitiative: {
    call: types.CreateInitiative;
    response: types.ProjectDetails;
  };
  CreateProject: {
    call: types.CreateProject;
    response: types.CreateProjectResponse;
  };
  CreateRoutine: { call: types.CreateRoutine; response: types.RoutineInfo };
  CreateTag: { call: types.CreateTag; response: types.CreateTagResponse };
  DeleteBot: { call: types.DeleteBot; response: types.DeleteBotResponse };
  DeleteCalendarEvent: {
    call: types.DeleteCalendarEvent;
    response: types.DeleteCalendarEventResponse;
  };
  DeleteDatabaseView: {
    call: types.DeleteDatabaseView;
    response: types.DeletedDatabaseView;
  };
  DeleteImportEntity: {
    call: types.DeleteImportEntity;
    response: types.DeleteImportEntityResponse;
  };
  DeleteInitiative: {
    call: types.DeleteInitiative;
    response: types.ProjectOperationComplete;
  };
  DeleteTag: { call: types.DeleteTag; response: types.DeleteTagResponse };
  DescribeDatabase: {
    call: types.DescribeDatabase;
    response: types.ToolDatabaseSchema;
  };
  DiscoverConnectors: {
    call: types.DiscoverConnectors;
    response: types.DiscoverConnectorsResponse;
  };
  DispatchCodingAgent: {
    call: types.DispatchCodingAgent;
    response: types.DispatchedCodingAgent;
  };
  DisplayResults: {
    call: types.DisplayResults;
    response: types.DisplayResultsResponse;
  };
  EditBookingLink: {
    call: types.EditBookingLink;
    response: types.BookingLinkResult;
  };
  EditDocument: {
    call: types.EditDocument;
    response: types.EditDocumentResponse;
  };
  EditForm: { call: types.EditForm; response: types.MutationResult };
  EditPresentation: {
    call: types.EditPresentation;
    response: types.PresentationEditOutcome;
  };
  EditSpreadsheet: {
    call: types.EditSpreadsheet;
    response: types.SpreadsheetResponse;
  };
  EditTag: { call: types.EditTag; response: types.EditTagResponse };
  EditWordDocument: {
    call: types.EditWordDocument;
    response: types.WordDocumentResponse;
  };
  GenerateImage: {
    call: types.GenerateImage;
    response: types.GenerateImageResponse;
  };
  GetBotWebhooks: {
    call: types.GetBotWebhooks;
    response: types.GetBotWebhooksResponse;
  };
  GetCompany: { call: types.GetCompany; response: types.GetCompanyResponse };
  GetEntityProperties: {
    call: types.GetEntityProperties;
    response: types.GetEntityPropertiesResponse;
  };
  GetTeamAvailability: {
    call: types.GetTeamAvailability;
    response: types.TeamAvailability;
  };
  GetThread: { call: types.GetThread; response: types.GetThreadResponse };
  ImportNotionPage: {
    call: types.ImportNotionPage;
    response: types.ImportNotionPageResponse;
  };
  IssueBotCredential: {
    call: types.IssueBotCredential;
    response: types.IssueBotCredentialResponse;
  };
  ListAgents: { call: types.ListAgents; response: types.ListAgentsResponse };
  ListBookingLinks: {
    call: types.ListBookingLinks;
    response: types.ListBookingLinksResult;
  };
  ListBots: { call: types.ListBots; response: types.ListBotsResponse };
  ListCalendarEvents: {
    call: types.ListCalendarEvents;
    response: types.ListCalendarEventsResponse;
  };
  ListCalendars: {
    call: types.ListCalendars;
    response: types.ListCalendarsToolResponse;
  };
  ListCodingAgents: {
    call: types.ListCodingAgents;
    response: types.ListCodingAgentsResponse;
  };
  ListCompanies: {
    call: types.ListCompanies;
    response: types.ListCompaniesResponse;
  };
  ListDatabases: {
    call: types.ListDatabases;
    response: types.ListDatabasesResponse;
  };
  ListEntities: {
    call: types.ListEntities;
    response: types.ListEntitiesResponse;
  };
  ListForms: { call: types.ListForms; response: types.ListResult };
  ListImportEntities: {
    call: types.ListImportEntities;
    response: types.ListImportEntitiesResponse;
  };
  ListInboxes: { call: types.ListInboxes; response: types.ListInboxesResponse };
  ListInitiatives: {
    call: types.ListInitiatives;
    response: types.ProjectListResult;
  };
  ListLabels: { call: types.ListLabels; response: types.ListLabelsResponse };
  ListNotifications: {
    call: types.ListNotifications;
    response: types.ListNotificationsResponse;
  };
  ListRoutines: { call: types.ListRoutines; response: types.RoutineList };
  ListSkills: { call: types.ListSkills; response: types.ListSkillsResponse };
  ListTags: { call: types.ListTags; response: types.ListTagsResponse };
  ListTeamMembers: {
    call: types.ListTeamMembers;
    response: types.ListTeamMembersResponse;
  };
  LoadTools: { call: types.LoadTools; response: types.LoadToolsResponse };
  ManageBotChannelAccess: {
    call: types.ManageBotChannelAccess;
    response: types.ManageBotChannelAccessResponse;
  };
  ManageChannelParticipants: {
    call: types.ManageChannelParticipants;
    response: types.ManageChannelParticipantsResponse;
  };
  MarkNotificationsDone: {
    call: types.MarkNotificationsDone;
    response: types.MarkNotificationsResponse;
  };
  MarkNotificationsSeen: {
    call: types.MarkNotificationsSeen;
    response: types.MarkNotificationsResponse;
  };
  MoveToProject: {
    call: types.MoveToProject;
    response: types.MoveToProjectResponse;
  };
  NameSearch: { call: types.NameSearch; response: types.SearchToolResponse };
  QueryDatabase: {
    call: types.QueryDatabase;
    response: types.QueryDatabaseResponse;
  };
  ReadActivity: {
    call: types.ReadActivity;
    response: types.ReadActivityResponse;
  };
  ReadCallRecord: {
    call: types.ReadCallRecord;
    response: types.ReadCallRecordResponse;
  };
  ReadChannelMessageContext: {
    call: types.ReadChannelMessageContext;
    response: types.ReadChannelMessageContextResponse;
  };
  ReadChannelMessages: {
    call: types.ReadChannelMessages;
    response: types.ReadChannelMessagesResponse;
  };
  ReadChannelThread: {
    call: types.ReadChannelThread;
    response: types.ReadChannelThreadResponse;
  };
  ReadChat: { call: types.ReadChat; response: types.ReadChatResponse };
  ReadContent: { call: types.ReadContent; response: types.ReadContentResponse };
  ReadDesign: { call: types.ReadDesign; response: types.ReadDesignResponse };
  ReadForm: { call: types.ReadForm; response: types.ReadResult };
  ReadIllustratorDocument: {
    call: types.ReadIllustratorDocument;
    response: types.ReadIllustratorDocumentResponse;
  };
  ReadInitiative: {
    call: types.ReadInitiative;
    response: types.ProjectReadResult;
  };
  ReadInitiativeActivity: {
    call: types.ReadInitiativeActivity;
    response: types.ProjectActivityResult;
  };
  ReadMetadata: {
    call: types.ReadMetadata;
    response: types.ReadMetadataResponse;
  };
  ReadPhotoshopDocument: {
    call: types.ReadPhotoshopDocument;
    response: types.ReadPhotoshopDocumentResponse;
  };
  ReadPresentation: {
    call: types.ReadPresentation;
    response: types.ReadPresentationResponse;
  };
  ReadProject: { call: types.ReadProject; response: types.ReadProjectResponse };
  ReadRoutine: { call: types.ReadRoutine; response: types.RoutineDetails };
  ReadSkill: { call: types.ReadSkill; response: types.ReadSkillResponse };
  ReadSpreadsheet: {
    call: types.ReadSpreadsheet;
    response: types.SpreadsheetResponse;
  };
  ReadThread: { call: types.ReadThread; response: types.ReadResponse };
  ReadWordDocument: {
    call: types.ReadWordDocument;
    response: types.WordDocumentResponse;
  };
  RenameChannel: {
    call: types.RenameChannel;
    response: types.RenameChannelResponse;
  };
  RenameDocument: {
    call: types.RenameDocument;
    response: types.RenameDocumentResponse;
  };
  ResolveDocumentComment: {
    call: types.ResolveDocumentComment;
    response: types.ResolveDocumentCommentResponse;
  };
  SaveDatabaseQuery: {
    call: types.SaveDatabaseQuery;
    response: types.SaveDatabaseQueryResponse;
  };
  SaveDatabaseView: {
    call: types.SaveDatabaseView;
    response: types.SavedDatabaseView;
  };
  SearchSkills: {
    call: types.SearchSkills;
    response: types.SearchSkillsResponse;
  };
  SearchTools: { call: types.SearchTools; response: types.SearchToolsResponse };
  SelfKnowledge: {
    call: types.SelfKnowledge;
    response: types.SelfKnowledgeResponse;
  };
  SendChannelMessage: {
    call: types.SendChannelMessage;
    response: types.SendChannelMessageResponse;
  };
  SendConfirmedEmail: {
    call: types.SendConfirmedEmail;
    response: types.SendEmailResponse;
  };
  SendEmail: {
    call: types.SendEmail;
    response: types.UserToolResponseForSendEmailResponse;
  };
  SetEntityProperty: {
    call: types.SetEntityProperty;
    response: types.SetEntityPropertyResponse;
  };
  SetFormAccess: { call: types.SetFormAccess; response: types.MutationResult };
  SetSenderPolicy: {
    call: types.SetSenderPolicy;
    response: types.SetSenderPolicyResponse;
  };
  ShareWithChannel: {
    call: types.ShareWithChannel;
    response: types.ShareWithChannelResponse;
  };
  Subagent: { call: types.Subagent; response: types.SubagentResponse };
  TextEditorCodeExecution: {
    call: types.TextEditorCodeExecution;
    response: types.TextEditorCodeExecutionResponse;
  };
  UpdateCalendarEvent: {
    call: types.UpdateCalendarEvent;
    response: types.ToolCalendarEvent;
  };
  UpdateInitiative: {
    call: types.UpdateInitiative;
    response: types.ProjectDetails;
  };
  UpdateInitiativeSharing: {
    call: types.UpdateInitiativeSharing;
    response: types.ProjectDetails;
  };
  UpdateRoutine: { call: types.UpdateRoutine; response: types.RoutineInfo };
  UpdateThreadLabels: {
    call: types.UpdateThreadLabels;
    response: types.UpdateThreadLabelsResponse;
  };
  UploadFile: { call: types.UploadFile; response: types.UploadFileResponse };
  WebFetch: { call: types.WebFetch; response: types.WebFetchResponse };
  WebSearch: { call: types.WebSearch; response: types.WebSearchResponse };
};

export type NamedTool<
  TName extends ToolName = ToolName,
  TDirection extends 'call' | 'response' = 'call' | 'response',
> = {
  id: string;
  name: TName;
  data: ToolDataMap[TName][TDirection];
};

function deserializeTool<T extends NamedTool>(
  tool: NamedRawTool,
  direction: 'call' | 'response'
): Result<T, ResultError<'parse_error' | 'not_found'>[]> {
  if (!(tool.name in toolParserMap)) {
    return err([
      { code: 'not_found', message: `tool name not found ${tool.name}` },
    ]);
  }
  const parser = toolParserMap[tool.name as ToolName];
  const maybeToolCall = parser[direction].safeParse(
    bookingLinkHistory(tool.name, direction, tool.json)
  );
  if (maybeToolCall.success) {
    return ok({
      id: tool.id,
      name: tool.name as ToolName,
      data: maybeToolCall.data,
    } as T);
  }
  return err([{ code: 'parse_error', message: 'tool parsing failed' }]);
}

export function deserializeToolCall(
  tool: NamedRawTool
): Result<
  NamedTool<ToolName, 'call'>,
  ResultError<'parse_error' | 'not_found'>[]
> {
  return deserializeTool(tool, 'call');
}

export function deserializeToolResponse(
  tool: NamedRawTool
): Result<
  NamedTool<ToolName, 'response'>,
  ResultError<'parse_error' | 'not_found'>[]
> {
  return deserializeTool(tool, 'response');
}
